module.exports = __webpack_public_path__ + "static/media/sidebar-4.7bc259fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-4.jpg
// module id = 187
// module chunks = 0